import { useState, useMemo, useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { SearchBar } from '@/components/common/SearchBar';
// import { useGetCertificatesQuery } from '@/store/api/certificateApi';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowBigLeft } from 'lucide-react';

export default function CertificatePage() {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 7,
  });
  const [levelFilter, setLevelFilter] = useState('All');
  // const { data, isLoading } = useGetCertificatesQuery({
  //   search: debouncedSearch,
  //   page: paginationModel.page + 1,
  //   limit: paginationModel.pageSize,
  // });
  const location = useLocation();

  const event = location.state?.event;
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);
  // const rows =
  //   data?.data?.map((item, index) => ({
  //     id: item._id,

  //     serial: paginationModel.page * paginationModel.pageSize + index + 1,

  //     title: item.title,
  //     certId: item._id,
  //     eventName: item.eventName,
  //     eventId: item.eventId,
  //     date: item.issuedAt ? new Date(item.issuedAt).toLocaleDateString() : '-',
  //     description: item.description,
  //     issuedBy: item.issuingAuthority || '-',
  //     level: item.level || 'N/A',
  //     type: item.type || 'N/A',
  //     eventLocation: item.eventLocation || '-',
  //     candidateCount: item.candidates?.length || 0,
  //     url: item.url || '#',
  //   })) || [];

  const filteredCertificates =
    event?.certificates?.filter((item: any) => {
      const matchesSearch = debouncedSearch
        ? item.title.toLowerCase().includes(debouncedSearch.toLowerCase())
        : true;

      const matchesLevel = levelFilter === 'All' ? true : item.level === levelFilter;

      return matchesSearch && matchesLevel;
    }) || [];
  const rows =
    filteredCertificates.map((item: any, index: number) => ({
      id: item._id,

      serial: index + 1,

      eventName: event?.certificates?.title,

      location: event?.place,

      eventDate: new Date(event?.date).toLocaleDateString(),

      totalCertificates: event?.totalCertificates,

      title: item.title,

      certId: item._id,

      description: item.description,

      issuedBy: item.issuingAuthority,

      level: item.level,

      issuedAt: new Date(item.issuedAt).toLocaleDateString(),
    })) || [];
  // const columns: GridColDef[] = [
  //   { field: 'serial', headerName: 'S.No', width: 80 },
  //   { field: 'eventName', headerName: 'Event Name', flex: 1 },

  //   {
  //     field: 'title',
  //     headerName: 'Certificate Title',
  //     flex: 1,
  //   },

  //   {
  //     field: 'description',
  //     headerName: 'Description',
  //     flex: 2,
  //     renderCell: (params) => (
  //       <div
  //         title={params.row.description}
  //         style={{
  //           whiteSpace: 'nowrap',
  //           overflow: 'hidden',
  //           textOverflow: 'ellipsis',
  //           maxWidth: '90%',
  //         }}
  //       >
  //         {params.row.description}
  //       </div>
  //     ),
  //   },
  //   { field: 'certId', headerName: 'Certificate ID', flex: 1 },
  //   // { field: 'level', headerName: 'Level', flex: 1 },
  //   // { field: 'eventId', headerName: 'Event ID', flex: 1 },
  //   { field: 'date', headerName: 'Date', flex: 1 },
  //   { field: 'eventLocation', headerName: 'Location', flex: 1 },
  //   { field: 'issuedBy', headerName: 'Issued By', flex: 1 },

  //   // {
  //   //   field: 'type',
  //   //   headerName: 'Certificate Type',
  //   //   width: 150,
  //   //   renderCell: (params) => (
  //   //     <span
  //   //       style={{
  //   //         background: '#DAE6E3',
  //   //         color: '#22c55e',
  //   //         padding: '4px 10px',
  //   //         border: '1px solid #28903E',
  //   //         borderRadius: '4px',
  //   //         fontSize: '12px',
  //   //       }}
  //   //     >
  //   //       {params.value}
  //   //     </span>
  //   //   ),
  //   // },

  //   // {
  //   //   field: 'preview',
  //   //   headerName: 'preview',
  //   //   width: 70,
  //   //   renderCell: (params) => (
  //   //     <IconButton
  //   //       onClick={() =>
  //   //         window.open(
  //   //           `https://docs.google.com/gview?url=${params.row.url}&embedded=true`,
  //   //           '_blank'
  //   //         )
  //   //       }
  //   //     >
  //   //       <ScanEye size={18} color="white" />
  //   //     </IconButton>
  //   //   ),
  //   // },

  //   // {
  //   //   field: 'download',
  //   //   headerName: 'Download',
  //   //   width: 70,
  //   //   renderCell: (params) => (
  //   //     <IconButton onClick={() => window.open(params.row.url, '_blank')}>
  //   //       <Download size={18} color="white" />
  //   //     </IconButton>
  //   //   ),
  //   // },
  // ];
  const columns: GridColDef[] = [
    {
      field: 'serial',
      headerName: 'S.No',
      width: 80,
    },

    {
      field: 'title',
      headerName: 'Certificate Title',
      flex: 1,
    },

    {
      field: 'location',
      headerName: 'Location',
      flex: 1,
    },

    {
      field: 'title',
      headerName: 'Certificate',
      flex: 1,
    },

    {
      field: 'level',
      headerName: 'Level',
      width: 130,
    },

    {
      field: 'issuedBy',
      headerName: 'Issued By',
      flex: 1,
    },

    {
      field: 'issuedAt',
      headerName: 'Issued Date',
      width: 140,
    },
  ];
  return (
    <div className="bg-black text-white p-2 lg:p-5 rounded-xl ">
      <div className="flex flex-col lg:flex-row justify-between lg:items-center mb-4">
        <div className="flex items-center gap-4">
          <div className="flex gap-2 items-center">
            <ArrowBigLeft onClick={() => navigate(-1)} />
            <h2 className="text-xl font-semibold ">certificates </h2>
          </div>
          {/* <p className="font-22 font-medium text-white pb-2.5">
            Showing{' '}
            <span className=" p-2 rounded-full bg-[#303170] text-white font-18 font-bold mx-1">
              {/* {data?.pagination.total} }
              {rows.length}
            </span>{' '}
            certificates
          </p> */}
        </div>
        <div className="flex gap-4">
          <select
            value={levelFilter}
            onChange={(e) => setLevelFilter(e.target.value)}
            className="bg-transparent border border-white/20 rounded-md px-3 py-2 text-sm text-white focus:outline-none focus:border-blue-500"
          >
            <option value="All" className="bg-black">
              All
            </option>

            <option value="Beginner" className="bg-black">
              Beginner
            </option>

            <option value="Intermediate" className="bg-black">
              Intermediate
            </option>

            <option value="Expert" className="bg-black">
              Expert
            </option>
          </select>
          <div className=" lg:w-[386px]">
            <SearchBar
              value={search}
              onChange={setSearch}
              placeholder="Search by  title..."
              className="w-64"
            />
          </div>
        </div>
      </div>

      <div style={{ height: 500 }}>
        {/* <DataGrid
          rows={rows}
          columns={columns}
          // checkboxSelection
          // loading={isLoading}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          //   rowSelectionModel={selectionModel}
          //   onRowSelectionModelChange={(newModel) => setSelectionModel(newModel)}
          // paginationMode="server"
          rowCount={data?.pagination?.total || 0}
          // rowCount={data?.pagination?.total || 0}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[5, 7, 10]}
          onRowClick={(params) => {
            navigate(`/certificates/${params.row.id}/users`);
          }}
          sx={{
            backgroundColor: '#000 !important',
            color: '#fff',

            '& .MuiDataGrid-main': {
              backgroundColor: '#000 !important',
            },
            '& .MuiDataGrid-overlay': {
              background: 'linear-gradient(178.14deg, #000000 1.65%, #6F72FF 180.97%)',
              color: '#fff',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#000 !important',
              color: '#fff !important',
              borderBottom: '1px solid #222',
            },

            '& .MuiDataGrid-columnHeader': {
              backgroundColor: '#000 !important',
            },

            '& .MuiDataGrid-columnHeaderTitle': {
              color: '#fff !important',
              fontWeight: 600,
            },

            '& .MuiDataGrid-row': {
              backgroundColor: '#000 !important',
              borderBottom: '1px solid #111',
              cursor: 'pointer',
            },

            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#111 !important',
            },

            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #111',
              color: '#fff',
            },

            '& .MuiCheckbox-root': {
              color: '#fff !important',
            },

            '& .MuiTablePagination-root': {
              color: '#fff',
            },

            '& .MuiDataGrid-footerContainer': {
              backgroundColor: '#000 !important',
              borderTop: '1px solid #222',
            },

            border: '1px solid #222',
          }}
        /> */}
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[5, 7, 10]}
          onRowClick={(params) => {
            navigate(`/certificates/${params.row.id}/users`);
          }}
          sx={{
            backgroundColor: '#000 !important',
            color: '#fff',

            '& .MuiDataGrid-main': {
              backgroundColor: '#000 !important',
            },
            '& .MuiDataGrid-overlay': {
              background: 'linear-gradient(178.14deg, #000000 1.65%, #6F72FF 180.97%)',
              color: '#fff',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#000 !important',
              color: '#fff !important',
              borderBottom: '1px solid #222',
            },

            '& .MuiDataGrid-columnHeader': {
              backgroundColor: '#000 !important',
            },

            '& .MuiDataGrid-columnHeaderTitle': {
              color: '#fff !important',
              fontWeight: 600,
            },

            '& .MuiDataGrid-row': {
              backgroundColor: '#000 !important',
              borderBottom: '1px solid #111',
              cursor: 'pointer',
            },

            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#111 !important',
            },

            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #111',
              color: '#fff',
            },

            '& .MuiCheckbox-root': {
              color: '#fff !important',
            },

            '& .MuiTablePagination-root': {
              color: '#fff',
            },

            '& .MuiDataGrid-footerContainer': {
              backgroundColor: '#000 !important',
              borderTop: '1px solid #222',
            },

            border: '1px solid #222',
          }}
        />
      </div>
    </div>
  );
}
